import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/upload.svg'
import _imports_1 from '@/assets/icons/more.svg'
import _imports_2 from '@/assets/icons/download.svg'


const _hoisted_1 = { class: "flex flex-col h-full mt-4" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Files", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Upload files")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-row mt-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-row justify-between" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "mx-2"
  })
], -1)
const _hoisted_11 = { class: "text-lg font-semibold mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-between items-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("button", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("span", { class: "text-primary ml-2" }, "Download")
    ])
  ])
], -1)
const _hoisted_13 = {
  key: 0,
  class: "mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfViewer = _resolveComponent("PdfViewer")!
  const _component_ModalUploadFile = _resolveComponent("ModalUploadFile")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
          class: "bg-primary text-white rounded-full px-4 py-1"
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: i,
            class: _normalizeClass(["flex flex-col bg-white shadow rounded text-left p-4 w-60", { 'ml-4': i > 0, 'border border-primary': file.selected }]),
            onClick: ($event: any) => (_ctx.selectFile(i, file.url))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: require(`@/assets/icons/${file.file_type}.svg`)
              }, null, 8, _hoisted_9),
              _hoisted_10
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(file.identifier), 1),
            _hoisted_12
          ], 10, _hoisted_7))
        }), 128))
      ]),
      (_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_PdfViewer, { file: _ctx.selectedFile }, null, 8, ["file"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalUploadFile, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openModal) = $event)),
      talentId: _ctx.talent_id
    }, null, 8, ["openModal", "talentId"])
  ]))
}